import React from 'react';

const ProgressBar = ({ currentSection, totalSections, sectionTitles }) => {
  const progress = ((currentSection + 1) / totalSections) * 100;
  const currentSectionName = sectionTitles[currentSection] || '';

  return (
    <div className="mt-4">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="h-2 rounded-full" style={{ backgroundColor: 'var(--succession-bg-secondary)', border: '1px solid var(--succession-border)' }}>
            <div
              className="h-2 rounded-full transition-all duration-300"
              style={{ width: `${progress}%`, backgroundColor: 'var(--succession-primary)' }}
            />
          </div>
        </div>
        <div className="ml-4 text-sm" style={{ color: 'var(--succession-text-secondary)' }}>
          {currentSection + 1} of {totalSections}
        </div>
      </div>
      <div className="mt-2 flex items-center justify-between text-sm">
        {currentSection > 0 && (
          <div style={{ color: 'var(--succession-text-tertiary)' }}>
            ← {sectionTitles[currentSection - 1]}
          </div>
        )}
        <div className="font-medium mx-2 truncate" style={{ color: 'var(--succession-primary)' }}>
          {currentSectionName}
        </div>
        {currentSection < totalSections - 1 && (
          <div style={{ color: 'var(--succession-text-tertiary)' }}>
            {sectionTitles[currentSection + 1]} →
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressBar; 